export default function NaturalFeeling() {
  return (
    <section className="py-20 px-6 bg-[#FFF8F3]">
      <div className="max-w-[1000px] mx-auto md:text-center text-left">
        <h2 className="text-3xl font-bold text-[#5A4033] mb-6 md:block hidden">
          その迷いは、とても自然なことです
        </h2>
        <h2 className="text-3xl font-bold text-[#5A4033] mb-6 md:hidden block text-left">
          その迷いは<br />
          とても自然なことです
        </h2>
        <p className="text-[#5A4033] leading-relaxed mb-6 text-left md:text-center">
          家づくりは、ほとんどの人が初めて経験することです。<br />
          専門用語も多く、判断基準も曖昧で、何が正しいのか分かりにくい。<br />
          だからこそ、迷うのは当然のことなのです。
        </p>
        <p className="text-[#5A4033] leading-relaxed text-left md:text-center">
          大切なのは、その迷いを一人で抱え込まないこと。<br />
          「わからない」を整理し、納得して進める状態をつくることです。
        </p>
      </div>
    </section>
  );
}